import React from "react";
import { Line } from "react-chartjs-2";
import "./index.css";

const Grafico = (props) => {
  const { datosGrafico, datosGraficot } = props;
  const result = [
    datosGrafico[2],
    datosGrafico[5],
    datosGrafico[8],
    datosGrafico[11],
    datosGrafico[14],
    datosGrafico[17],
    datosGrafico[20],
    datosGrafico[23],
  ];
  const resultt = [
    datosGraficot[2],
    datosGraficot[5],
    datosGraficot[8],
    datosGraficot[11],
    datosGraficot[14],
    datosGraficot[17],
    datosGraficot[20],
    datosGraficot[23],
  ];

  const data = {
    labels: result,
    datasets: [
      {
        label: "temperatura",
        data: resultt,
        fill: false,
        backgroundColor: "white" /*'rgb(255, 99, 132)',*/,
        borderColor: "white" /*'rgba(255, 99, 132, 0.2)'*/,
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    legend: false /* {
      labels: {
        fontColor: "white",
        fontSize: 16,
      },
    }*/,
    scales: {

      yAxes: [
        {      
          gridLines:{color:"gray"},
          ticks: {
            fontColor: "white",
            beginAtZero: false,
            min: Math.min(...datosGraficot) - 1,
            max: Math.max(...datosGraficot) + 1,
          },
        },
      ],
      xAxes: [
        {gridLines:{color:"gray"},
          ticks: {
            fontColor: "white",
          },
        },
      ],
    },
  };

  return (
    <div className="container-grafico">
      {datosGrafico ? <Line data={data} options={options} /> : null}
    </div>
  );
};

export default Grafico;
